<template>
  <div>
    <div id="cover-image">
      <img :src="require('@/assets/background-student-profile.png')" alt />
      <div id="img-frame" class="text-center mb-1">
        <img
          v-lazy="{
            src: photoStudent(data),
            error: onError(data),
            loading: require('@/assets/Rolling-1s-200px_2.svg')
          }"
        />
      </div>
    </div>
    <div class="row form-group m-b-15">
      <div class="col-md-12 text-center">
        <span>{{ data.card_number }}</span>
        <h3
          class="text-center ts-font-bold ts-text-lg mt-2 mb-0 text-uppercase text-primary"
        >
          {{ data.full_name_en }}
        </h3>
      </div>
    </div>
    <ts-card-wrapper>
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <span>
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.nameKh')
            }}
          </span>
          <p class="pull-right kh-font">
            {{ data.full_name_kh ? data.full_name_kh : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.nameEn')
            }}
          </span>
          <p class="pull-right">
            {{ data.full_name_en ? data.full_name_en : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{
              $t('school.academic.operation.profile_mgt.studentProfile.gender')
            }}
          </span>
          <p class="pull-right">
            {{ data.gender ? data.gender : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{
              $t(
                'school.academic.operation.profile_mgt.studentProfile.dateOfBirth'
              )
            }}
          </span>
          <p class="pull-right">
            {{ data.date_of_birth ? data.date_of_birth : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{
              $t(
                'school.academic.operation.profile_mgt.studentProfile.nationality'
              )
            }}
          </span>
          <p class="pull-right">
            {{
              data.nationality_resource
                ? data.nationality_resource.nationality
                : '-'
            }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{
              $t(
                'school.academic.operation.profile_mgt.studentProfile.religion'
              )
            }}
          </span>
          <p class="pull-right">
            {{ data.religion_resource ? data.religion_resource.religion : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{
              $t(
                'school.academic.operation.profile_mgt.studentProfile.registerDate'
              )
            }}
          </span>
          <p class="pull-right">
            {{ data.registered_date ? data.registered_date : '-' }}
          </p>
        </li>
        <li class="list-group-item">
          <span>
            {{
              $t(
                'school.academic.operation.profile_mgt.studentProfile.serialFingerPrint'
              )
            }}
          </span>
          <p class="pull-right">
            {{
              data.serial_finger_print_no ? data.serial_finger_print_no : '-'
            }}
          </p>
        </li>
      </ul>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'profile-information-show',
  props: ['value'],
  data() {
    return {
      data: {},
      errors: new Errors(),
      boyPhoto: require('../../../../assets/student-default-boy.png'),
      girlPhoto: require('../../../../assets/student-default-girl.png'),
      file: require('../../../../assets/user_default.png')
    }
  },
  created() {
    this.data = this.value
  },
  methods: {
    photoStudent(record) {
      if (record.photo) {
        return record.photo
      }
      return record.gender == 'Male' ? this.boyPhoto : this.girlPhoto
    },

    onError(record) {
      event
        ? (event.target.src =
            record.gender == 'Male' ? this.boyPhoto : this.girlPhoto)
        : this.file
    }
  }
}
</script>
<style lang="css" scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.list-group-item {
  border: none !important;
  padding: 10px 0 10px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -19%;
}
#img-frame img {
  object-fit: contain;
  width: 25%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
